import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import cx from 'classnames';
import Image from 'next/image';
import '../../../styles/flags.css';
import { Cloud$Market } from '../../../types/cloudEnums';

type MarketList = Cloud$Market[];

type Props = {
  displayItem: (market: Cloud$Market) => React.ReactNode;
  items: MarketList;
  onChange: (market: Cloud$Market) => void;
  selectedItem: Cloud$Market;
};

const MarketDropdownSelect = ({
  displayItem,
  items,
  onChange,
  selectedItem,
}: Props) => {
  return (
    <Menu>
      <MenuButton className="mt-2 flex items-center gap-2 rounded border-0 bg-grey-1 p-2 ring-1 ring-grey-10 transition-all data-focus:ring-2 data-focus:ring-digital data-focus:outline-none">
        <Image
          alt="Flag"
          width={44}
          height={30}
          unoptimized
          className={`flag flag-${selectedItem} rounded border border-grey-20`}
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeAQMAAABt+G7kAAAAA1BMVEVMaXFNx9g6AAAAAXRSTlMA
          QObYZgAAAAtJREFUeF5jGHYAAADSAAEzF5gpAAAAAElFTkSuQmCC"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24px"
          height="24px"
        >
          <path fill="none" d="M0 0h24v24H0z" />
          <path d="M12 14l-4-4h8z" />
        </svg>
      </MenuButton>
      <MenuItems
        anchor="bottom start"
        data-testid="language-switcher-dropdown"
        className="z-50 flex !max-h-60 w-24 flex-col rounded-md bg-white text-left shadow-2xl [--anchor-gap:4px] focus-visible:outline-none md:w-32"
      >
        {items.map((item) => (
          <MenuItem
            as="button"
            className={cx(
              'z-60 px-2 py-3 text-left hover:cursor-pointer data-focus:bg-blue-70 data-focus:text-white',
              selectedItem === item && 'bg-grey-5',
            )}
            key={item}
            value={item}
            onClick={() => onChange(item)}
          >
            <img
              alt="Flag"
              width={44}
              height={30}
              className={`flag mr-2 h-auto w-6 align-middle flag-${item} inline-block`}
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeAQMAAABt+G7kAAAAA1BMVEVMaXFNx9g6AAAAAXRSTlMA
              QObYZgAAAAtJREFUeF5jGHYAAADSAAEzF5gpAAAAAElFTkSuQmCC"
            />
            <p className="hidden align-middle text-base leading-3 md:inline-block">
              {displayItem(item)}
            </p>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};

export default MarketDropdownSelect;
